import { render, staticRenderFns } from "./step_budget_component_and_resource_base.vue?vue&type=template&id=7c0e174e&scoped=true"
import script from "./step_budget_component_and_resource_base.vue?vue&type=script&lang=js"
export * from "./step_budget_component_and_resource_base.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c0e174e",
  null
  
)

export default component.exports